import { UploadsApi } from "@/api/uploads.api";
import { LoaderFunctionArgs } from "react-router-dom";

export default async function adminProfileUploadsLoader({
  params,
}: LoaderFunctionArgs) {
  const { userId } = params;

  if (!userId) {
    throw new Error("User ID is required");
  }

  const uploads = await UploadsApi.getUploadsByUserId(userId);

  return { uploads: uploads.data };
}
